export const isEmptyString = (str) => (str || "").trim() === "";
